import get from 'lodash/get'
import React, { useMemo } from 'react'
import { Draggable } from 'react-beautiful-dnd'

import { getNewUuid } from '@avantstay/backoffice-core'

import { DragAndDropStatusProps, IDragAndDropItemProps } from '../_types'

export function DragAndDropItem<ItemType extends DragAndDropStatusProps>({
  item,
  index,
  render,
}: IDragAndDropItemProps<ItemType>) {
  const hash = useMemo(() => getNewUuid(), [])
  const itemId = get(item, 'id')

  return (
    <Draggable draggableId={`file-${hash}-${itemId}`} index={index} isDragDisabled={item.disabled}>
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
          {render(item, index)}
        </div>
      )}
    </Draggable>
  )
}
